import { getTranslations } from "@/lib/translations";
import { RedirectError } from "@/lib/errors";

import { requireStaff } from "@/core/auth/admin-guard";
import { createPlaceService } from "@/core/services/factory";
import { getPlaceSharePath } from "@/core/services/types/place.types";

export async function createPlaceAction(
  input: { name?: string } = {},
): Promise<{ redirectTo: string }> {
  await requireStaff();

  const t = getTranslations("places.library");
  const result = await createPlaceService().createPlace(
    input.name ? { name: input.name.trim() } : {},
  );

  if (!result.success) {
    throw new Error(t("createFailed"));
  }

  return { redirectTo: getPlaceSharePath(result.data.id) };
}

export async function createPlaceQuickAddAction(input: {
  name: string;
}): Promise<void> {
  await requireStaff();

  const t = getTranslations("places.library");
  const result = await createPlaceService().createPlace({
    name: input.name.trim(),
    status: "SIGNAL",
  });

  if (!result.success) {
    throw new Error(
      result.error === "signal_status_failed"
        ? t("createSignalFailed")
        : t("createFailed"),
    );
  }
}
